
import { authHeader } from '../util/authHeader'

import store from '../store'

let baseUrl = process.env.VUE_APP_API_BASE_URL

export const userService = {
  login,
  register,
  logout,
  changePassword,
  resetPassword,
  checkUser
}

function login (resellerId, username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resellerId, username, password })
  }

  return fetch(baseUrl + `/api/v1/auth/signin/`, requestOptions)
    .then(handleResponse)
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        // localStorage.setItem('user', JSON.stringify(user));
      }

      return user
    })
}

function register (resellerId, username, autoLogin) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resellerId, username, SignIn: autoLogin })
  }

  return fetch(baseUrl + `/api/v1/auth/register/`, requestOptions)
    .then(handleResponse)
    .then(user => {
      return user
    })
}

function resetPassword (resellerId, username) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resellerId, username })
  }

  return fetch(baseUrl + `/api/v1/auth/reset/`, requestOptions)
    .then(handleResponse)
    .then(user => {
      return user
    })
}

function changePassword (resellerId, username, password, newPassword) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({ resellerId, username, password, newPassword })
  }

  return fetch(baseUrl + `/api/v1/auth/change/`, requestOptions)
    .then(handleResponse)
    .then(user => {
      // login successful if there's a jwt token in the response
      // if (user.token) {
      //     // store user details and jwt token in local storage to keep user logged in between page refreshes
      //     //localStorage.setItem('user', JSON.stringify(user));
      // }

      return user
    })
}

function checkUser (resellerId, username) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resellerId, username })
  }

  return fetch(baseUrl + `/api/v1/auth/userexists/`, requestOptions)
    .then(handleResponse)
    .then(user => {
      return user
    })
}

function logout () {
  // remove user from local storage to log user out
  localStorage.removeItem('user')
  store.dispatch('authentication/logout')
}

function getAll () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`/users`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    let data = null //text && JSON.parse(text)
    try {
      data = JSON.parse(text)
    } catch {
      data = text
    }
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout()
        location.reload(true)
      }
      const error = data //(data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}
